import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export interface EligibilityQuestion {
  name: string;
  short_name: string;
}

export default class Pmsdatasource extends Model {
  [Type] = 'pmsdatasource' as const;

  @attr declare eligibilityQuestions: EligibilityQuestion[];
  @attr declare otbSelfserviceTranslationKeys: unknown;
  @attr('string') declare otherSystemDisplayName: string;
  @attr declare setupSteps: unknown;
}
